import { inject, Injectable } from '@angular/core';
import { Role } from '../models/role.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Permission } from '../models/permission';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor() {}

  private apiUrl = environment.apiUrl + '/Roles';
  private permApiUrl = environment.apiUrl + '/Permission';

  http = inject(HttpClient);

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.apiUrl + '/GetRoles');
  }

  postRole(role: Role): Observable<Role> {
    const data = {
      isParticipant: role.isParticipant,
      roleName: role.roleName,
      permissions: role.permissions
        ? [...role.permissions.map((p) => p.name)]
        : [],
      scope: role.scope,
    };
    return this.http.post<Role>(this.apiUrl + '/CreateRole', data);
  }

  putRole(role: Role): Observable<Role> {
    const data = {
      isParticipant: role.isParticipant,
      roleName: role.roleName,
      permissions: [...role.permissions.map((p) => p.name)],
      scope: role.scope,
    };
    return this.http.put<Role>(
      this.apiUrl + `/UpdateRoleByAdmin/${role.roleId}`,
      data,
    );
  }

  getPermissions(): Observable<Permission[]> {
    return this.http.get<Permission[]>(this.permApiUrl + '/GetAll');
  }

  deleteRole(roleId: number): Observable<void> {
    return this.http.delete<void>(this.apiUrl + `/DeleteRole`, {
      params: { roleId },
    });
  }

  getParticipantRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.apiUrl + '/GetParticipantRoles');
  }
}
